@use '@/styles/tokens' as *;

.readonly {
  color: $color-neutral-950;
}

.filled {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: $color-neutral-950;
}

.add,
.edit {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: $color-neutral-700;
}
